import notify from 'devextreme/ui/notify';
import Axios from '../api/axios';
import * as glb from '../globals';

let handoffOpen = false;

export async function openSsHandoff(target) {
  if (handoffOpen) return;
  handoffOpen = true;
  const popup = window.open('', '_blank');
  try {
    const firRef = glb.default?.KULLANICI?.KUL_DEF_FIR_REF ?? glb.default?.KULLANICI?.KUL_FIR_REF;
    const response = await Axios.post(
      `${process.env.REACT_APP_BACKEND_SERVER}authusr/ss-handoff`,
      { target, firRef },
    );
    const url = response?.data?.url;
    if (!url) throw new Error('Geçiş adresi alınamadı');
    if (response.data.created) {
      notify('Kullanıcı karşı sistemde tanımlandı.', 'success', 2500);
    }
    if (popup && !popup.closed) popup.location.href = url;
    else notify('Tarayıcı yeni sekmeyi engelledi.', 'warning', 4000);
  } catch (error) {
    if (popup && !popup.closed) popup.close();
    const message = error?.response?.data?.message || error?.message || 'Geçiş başarısız';
    notify(message, 'error', 4000);
  } finally {
    handoffOpen = false;
  }
}
